var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showTitle
        ? _c("div", { staticClass: "d-flex justify-space-between" }, [
            _c("p", { staticClass: "font-weight-black" }, [
              _vm.allowEdit ? _c("span", [_vm._v("EDITAR")]) : _vm._e(),
              _vm._v(" OBJECIÓN"),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-form",
        { ref: "formObjection", attrs: { "lazy-validation": "" } },
        [
          _c(
            "v-row",
            { staticClass: "fill-height px-3 pt-2" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-select", {
                    staticClass: "pt-2",
                    staticStyle: { "font-size": "15px" },
                    attrs: {
                      value: _vm.getTicket.objection,
                      items: _vm.getTicketDefaultObjections,
                      label: "Objeción",
                    },
                    model: {
                      value: _vm.objection,
                      callback: function ($$v) {
                        _vm.objection = $$v
                      },
                      expression: "objection",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.responseMessage
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-alert", { attrs: { text: "", type: "error" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.responseMessage) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEdit
                ? _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loading,
                            small: "",
                            rounded: "",
                            color: "primary",
                          },
                          on: { click: _vm.onSave },
                        },
                        [_vm._v(" Guardar ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", rounded: "" },
                          on: { click: _vm.onCancel },
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }